import { render, staticRenderFns } from "./InfoPointsConsole.vue?vue&type=template&id=bbaf3c84&scoped=true&"
import script from "./InfoPointsConsole.vue?vue&type=script&lang=js&"
export * from "./InfoPointsConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaf3c84",
  null
  
)

export default component.exports